<mat-card class="mcd-card">
  <mat-card-header
    class="mcd-card-header"
    style="
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      background: transparent;
      border: 1px solid #a0a0a04d;
      color: #34393f;
      border-left: none;
    "
  >
    <mat-card-title class="mcd-card-title">View All Equipment</mat-card-title>
  </mat-card-header>
  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row">
      <div class="col filter-panel">
        <app-location-type-filter
          [standardFiltration]="standardFiltrationForChipSet"
          [standardListType]="standardListType.NationalEquipment"
          (messageEvent)="receivedFilteration($event)"
          (searchApplied)="onSearchFromChild($event)"
          [searchKeyFromParent]="searchKey"
          [allCountries]="countries"
          (countrySelected)="onCountryfromChild($event)"
          (exportListFilter)="handleExport($event)"
          (countryListFilter)="handleCountryList($event)"
        ></app-location-type-filter>
      </div>
      <div class="collpsible-panel">
        <button class="btn-collapse" mat-icon-button aria-label="Collapse">
          <i class="material-icons"> expand_less </i>
        </button>
        <button class="btn-expand" mat-icon-button aria-label="Expand">
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="!loading">
      <div class="row">
        <!-- <div class="col-md-9">
          <mat-form-field>
            <input
              matInput
              placeholder="Search by Title, Model or Description"
              value="{{ searchKey }}"
              (keyup.enter)="addSearchKey(key)"
              name="search"
              #key
            />
            <button
              mat-button
              *ngIf="searchKey"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="searchKey = ''; addSearchKey(searchKey)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div> -->

        <!-- <div class="col float-right">
         
          <a *ngIf="isDownloading" class="float-right" disabled>
            Downloading, Please wait...
            <svg
              class="fontawesomesvg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path
                d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
              />
            </svg>
          </a>
          <a
            *ngIf="!isDownloading"
            class="float-right"
            href="javascript:void(0);"
            (click)="downloadExcel()"
            style="color: #0b59ca; text-decoration: none; cursor: pointer"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-bottom: 2px; margin-right: 2px"
            >
              <path
                d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Download All
          </a>
         
        </div> -->
      </div>
      <div class="row">
        <!-- <div class="col-6" *ngIf="this.equipmentItems.length > 0">
          <mat-form-field>
            <mat-select
              [value]="pageSize"
              name="nOfRows"
              #items
              (selectionChange)="selectedItemsPerPageChange(items)"
            >
              <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->

        <!-- <div class="col">
          <mat-form-field class="float-right">
            <mat-label>Country</mat-label>
            <mat-select
              name="dropCategory"
              [value]="selectedCountryId"
              #country
              (selectionChange)="selectCountry(country)"
            >
              <mat-option
                *ngFor="let item of countries; let j = index"
                [value]="item.id"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div> -->
      </div>
      <div *ngIf="this.equipmentItems.length > 0" class="col-md-12">
        <!-- TABLE 1: When NO country is selected (Standards) -->
        <table
          matSort
          (matSortChange)="sortData($event)"
          class="table nrbes-grid"
          *ngIf="!isCountrySelected && equipmentItems.length > 0"
        >
          <thead class="thead-light">
            <tr>
              <th scope="col" mat-sort-header="title" width="24%">
                <div class="title-cell-wrapper">
                  <mat-checkbox *ngIf="getSelectableRowsOnPage().length > 0"
                    color="primary"
                    [checked]="isAllOnPageSelected()" [indeterminate]="isSomeOnPageSelected()"
                    (click)="$event.stopPropagation()"
                    (change)="selectAllOnPageChange($event)"></mat-checkbox>
                  <span>Equipment Name</span>
                </div>
              </th>
              <th width="16%" mat-sort-header="type" scope="col">Type</th>
              <th scope="col" mat-sort-header="model" width="13%">Model</th>
              <th scope="col" width="18%">Location</th>
              <th scope="col" mat-sort-header="class" width="13%">Class</th>
              <th width="12%" mat-sort-header="supplier" scope="col">
                Supplier
              </th>
              <th scope="col" width="4%" *ngIf="isGlobalAdmin()"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of equipmentItems" (click)="rowSelected(item)">
              <td
                class="title-cell"
                style="font-weight: 500; color: #3949a3; font-size: 14px; padding: 12px;"
              >
                <div class="title-cell-wrapper">
                  <mat-checkbox
                    color="primary"
                    [checked]="isSelected(item.id || item.standard?.id)"
                    (click)="$event.stopPropagation()"
                    (change)="onCheckboxChange($event, item.id || item.standard?.id)"></mat-checkbox>
                  <span class="standard-title-text">{{ item.title || item.standard?.title }}</span>
                </div>
              </td>
              <td class="category-cell">
                {{ item.equipmentStandard?.equipmentType?.name || item.standard?.equipmentStandard?.equipmentType?.name }}
              </td>
              <td class="location-cell">
                {{ item.equipmentStandard?.model || item.standard?.equipmentStandard?.model }}
              </td>
              <td class="category-cell">
                {{ getLocationNames(item) }}
              </td>
              <td class="location-cell">
                {{ item.equipmentStandard?.equipmentClassType?.name || item.standard?.equipmentStandard?.equipmentClassType?.name }}
              </td>
              <td class="category-cell">
                {{ item.equipmentStandard?.supplier?.name || item.standard?.equipmentStandard?.supplier?.name }}
              </td>
              <td *ngIf="isGlobalAdmin()">
                <div class="grid-actions hide-sm" *ngIf="selectedRowsForExport.length < 2">
                  <button
                    style="border: none; background: none"
                    (click)="togglePopup($event, item)"
                  >
                    <img src="/assets/images/menu-dots 2.svg" />
                  </button>
                  <div
                    class="action-popup editDeletModal"
                    *ngIf="activePopupId === item.id"
                  >
                    <!-- Edit Option -->
                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="onEditHover"
                      (click)="onEdit(item.id || item.standardId || item.standard?.id, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: rgba(63, 81, 181, 1);
                          font-size: 14px;
                          text-align: left;
                          display: block;
                          width: 100%;
                        "
                        routerLinkActive="active"
                        title="Edit"
                        href="javascript:void(0);"
                      >
                        <span
                          ><img
                            src="/assets/images/d-edit 1.svg"
                            style="margin-bottom: 4px; margin-right: 5px"
                        /></span>
                        <span>Edit</span>
                      </a>
                    </div>

                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="onEditHover"
                      *ngIf="showAddExceptionAction(item)"
                      (click)="addAddendumFromList(item, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: #3f51b5;
                          font-size: 14px;
                          display: block;
                          width: 100%;
                        "
                        routerLinkActive="active"
                        title="Add"
                        href="javascript:void(0);"
                      >
                        <span
                          ><img
                            src="/assets/images/file-new 1.svg"
                            style="margin-bottom: 4px; margin-right: 5px"
                        /></span>
                        <span>Add Exception</span>
                      </a>
                    </div>

                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="onEditHover"
                      *ngIf="showGoToExceptionAction(item)"
                      (click)="goToAddendumFromList(item, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: #3f51b5;
                          font-size: 14px;
                          display: block;
                          width: 100%;
                        "
                        href="javascript:void(0);"
                      >
                        <span
                          ><img
                            src="/assets/images/file-new 1.svg"
                            style="margin-bottom: 4px; margin-right: 5px"
                        /></span>
                        <span>Go to Exception</span>
                      </a>
                    </div>

                    <hr style="margin: 2px; border: 1px solid #dde1e6" />
                    <!-- Delete Option -->
                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="oDeleteHover"
                      (click)="openDeletePopup(item, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: rgba(222, 52, 40, 1);
                          font-size: 14px;
                          display: block;
                          width: 100%;
                        "
                        routerLinkActive="active"
                        title="clear"
                      >
                        <span
                          ><img
                            src="/assets/images/bin.svg"
                            style="margin-bottom: 4px; margin-right: 5px"
                        /></span>
                        <span>Delete</span>
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- TABLE 2: When country IS selected (NRBES) -->
        <table
          class="table nrbes-grid"
          matSort
          (matSortChange)="sortData($event)"
          *ngIf="isCountrySelected && equipmentItems.length > 0"
        >
          <thead class="thead-light">
            <tr>
              <th scope="col" mat-sort-header="title" width="24%">
                <div class="title-cell-wrapper">
                  <mat-checkbox *ngIf="getSelectableRowsOnPage().length > 0"
                    color="primary"
                    [checked]="isAllOnPageSelected()" [indeterminate]="isSomeOnPageSelected()"
                    (click)="$event.stopPropagation()"
                    (change)="selectAllOnPageChange($event)"></mat-checkbox>
                  <span>Equipment Name</span>
                </div>
              </th>
              <th width="16%" mat-sort-header="type" scope="col">Type</th>
              <th scope="col" mat-sort-header="model" width="13%">Model</th>
              <th scope="col" width="18%">Location</th>
              <th scope="col" mat-sort-header="class" width="13%">Class</th>
              <th width="12%" mat-sort-header="supplier" scope="col">
                Supplier
              </th>
              <th scope="col" width="4%" *ngIf="isGlobalAdmin()"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of equipmentItems" (click)="rowSelected(item)">
              <td
                class="title-cell"
                style="font-weight: 500; color: #3949a3; font-size: 14px; padding: 12px;"
              >
                <div class="title-cell-wrapper">
                  <mat-checkbox
                    color="primary"
                    [checked]="isSelected(item.id || item.standard?.id)"
                    (click)="$event.stopPropagation()"
                    (change)="onCheckboxChange($event, item.id || item.standard?.id)"></mat-checkbox>
                  <span class="standard-title-text">{{ item.standard?.title || item.title }}</span>
                </div>
              </td>
              <td class="category-cell">
                {{ item.standard?.equipmentStandard?.equipmentType?.name || item.equipmentStandard?.equipmentType?.name }}
              </td>
              <td class="location-cell">
                {{ item.standard?.equipmentStandard?.model || item.equipmentStandard?.model }}
              </td>
              <td class="category-cell">
                {{ getLocationNames(item) }}
              </td>
              <td class="location-cell">
                {{ item.standard?.equipmentStandard?.equipmentClassType?.name || item.equipmentStandard?.equipmentClassType?.name }}
              </td>
              <td class="category-cell">
                {{ item.standard?.equipmentStandard?.supplier?.name || item.equipmentStandard?.supplier?.name }}
              </td>
              <td *ngIf="isGlobalAdmin()">
                <div class="grid-actions hide-sm" *ngIf="selectedRowsForExport.length < 2">
                  <button
                    style="border: none; background: none"
                    (click)="togglePopup($event, item)"
                  >
                    <img src="/assets/images/menu-dots 2.svg" />
                  </button>
                  <div
                    class="action-popup editDeletModal"
                    *ngIf="activePopupId === item.id"
                  >
                    <!-- Edit Option -->
                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="onEditHover"
                      (click)="onEdit(item.standardId || item.id || item.standard?.id, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: rgba(63, 81, 181, 1);
                          font-size: 14px;
                          text-align: left;
                          display: block;
                          width: 100%;
                        "
                        routerLinkActive="active"
                        title="Edit"
                        href="javascript:void(0);"
                      >
                        <span
                          ><img
                            src="/assets/images/d-edit 1.svg"
                            style="margin-bottom: 4px; margin-right: 5px"
                        /></span>
                        <span>Edit</span>
                      </a>
                    </div>

                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="onEditHover"
                      *ngIf="showAddExceptionAction(item)"
                      (click)="addAddendumFromList(item, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: #3f51b5;
                          font-size: 14px;
                          display: block;
                          width: 100%;
                        "
                        routerLinkActive="active"
                        title="Add"
                        href="javascript:void(0);"
                      >
                        <span
                          ><img
                            src="/assets/images/file-new 1.svg"
                            style="margin-bottom: 4px; margin-right: 5px"
                        /></span>
                        <span>Add Exception</span>
                      </a>
                    </div>

                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="onEditHover"
                      *ngIf="showGoToExceptionAction(item)"
                      (click)="goToAddendumFromList(item, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: #3f51b5;
                          font-size: 14px;
                          display: block;
                          width: 100%;
                        "
                        href="javascript:void(0);"
                      >
                        <span
                          ><img
                            src="/assets/images/file-new 1.svg"
                            style="margin-bottom: 4px; margin-right: 5px"
                        /></span>
                        <span>Go to Exception</span>
                      </a>
                    </div>

                    <hr style="margin: 2px; border: 1px solid #dde1e6" />
                    <!-- Delete Option -->
                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="oDeleteHover"
                      (click)="openDeletePopup(item, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: rgba(222, 52, 40, 1);
                          font-size: 14px;
                          display: block;
                          width: 100%;
                        "
                        routerLinkActive="active"
                        title="clear"
                      >
                        <span
                          ><img
                            src="/assets/images/bin.svg"
                            style="margin-bottom: 4px; margin-right: 5px"
                        /></span>
                        <span>Delete</span>
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Loading and Empty States -->
        <div *ngIf="loading" class="text-center p-5">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
        </div>

        

        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
          *ngIf="equipmentItems.length > 0"
        >
          <div>
            <div>
              <mat-form-field>
                <mat-select
                  style="
                    padding: 8px 16px;
                    border: 1px solid #dde1e6;
                    border-radius: 4px;
                    background-color: #f8fafb;
                    color: #4d5258;
                    font-weight: 500;
                  "
                  [value]="pageSize"
                  name="nOfRows"
                  #items
                  (selectionChange)="selectedItemsPerPageChange(items)"
                >
                  <mat-option
                    [value]="item.value"
                    *ngFor="let item of pageSizes"
                  >
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div>
            <div>
              <ngb-pagination
                class="float-right"
                [(page)]="page"
                [pageSize]="pageSize"
                [maxSize]="4"
                [rotate]="true"
                [ellipses]="true"
                [collectionSize]="collectionSize"
                (pageChange)="onPageChange()"
              ></ngb-pagination>
            </div>
          </div>

          <div style="display: flex; gap: 10px">
            <button
              class="prevButton"
              [ngStyle]="{
                border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
                color: page == 1 ? '#696F77' : '#34393f',
              }"
              (click)="goToPreviousPage()"
            >
              <img src="/assets/images/leftarrow.svg" />

              Previous
            </button>
            <button
              class="nextButton"
              [ngStyle]="{
                border:
                  page == totalPages
                    ? '1px solid #E9ECEF'
                    : '1px solid #C1C6CD',
                color: page == totalPages ? '#696F77' : '#34393f',
              }"
              (click)="goToNextPage()"
            >
              Next
              <img src="/assets/images/rightarrow.svg" />
            </button>
          </div>
        </div>
      </div>

      <!-- <div class="row" *ngIf="equipmentItems.length > 0">
        <div class="col">
          <ngb-pagination
            class="float-right"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="4"
            [rotate]="true"
            [ellipses]="true"
            [collectionSize]="collectionSize"
            (pageChange)="getAllNrbesBySelectedCountryId()"
          >
          </ngb-pagination>
        </div>
      </div> -->
      <div class="row">
        <div
          *ngIf="
            equipmentItems.length == 0 &&
              !loading &&
              !searchKey &&
              this.userRole == 4;
            else elseBlock
          "
        >
          Please select a country to view the standards.
        </div>
        <ng-template #elseBlock>
          <div *ngIf="equipmentItems.length == 0 && !searchKey && !loading" class="noResults">
            Sorry you do not have any equipment standard.
          </div>

          <div *ngIf="equipmentItems.length == 0 && searchKey && !loading" class="search-empty-state">
            <img
              src="/assets/images/GRBES-List.svg"
              alt=""
              class="search-empty-icon"
            />
            <h4 class="search-empty-title">No results found</h4>
            <p class="search-empty-subtitle">
              Try a different keyword or refine your search to find what you're
              looking for.
            </p>
          </div>
        </ng-template>
      </div>
    </div>
    <app-mcd-loader *ngIf="loading"></app-mcd-loader>
  </mat-card-content>
</mat-card>
